import React from "react";
import { Component } from "react";

export default class GridLabels extends Component {
  render() {
    const { labs } = this.props;
    return labs && labs.groups ? (
      <div className="grid-labels">
        {labs.groups.map((group, i) => (
          <React.Fragment key={group.title}>
            <table className="group-title">
              <thead>
                <tr>
                  <th>
                    <div>{group.title}</div>
                  </th>
                </tr>
              </thead>
            </table>
            <table key={i}>
              <tbody>
                {group.items
                  ? group.items.map((item) => (
                      <tr key={item.title}>
                        <td>
                          <div className="metric">{item.title}</div>
                          <div className="unit">{item.subtitle}</div>
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </table>
          </React.Fragment>
        ))}
      </div>
    ) : null;
  }
}
